import LoopFront from "loop-front";

class Tag extends LoopFront {
    constructor() {
        super('tags');
    }
}

export const OTag = new Tag();